module.exports = __webpack_public_path__ + "static/media/plated-risotto@2x.b6a1377a.png";